import { useQuery } from "@tanstack/react-query";
import ManageWrapper from "..";
import Something from "../../../components/common/Something";
import CreateCountry from "./components/CreateCategory";
import { FiEdit } from "react-icons/fi";
import { RiDeleteBin4Line } from "react-icons/ri";
import { BsEye } from "react-icons/bs";
import UpdateCategory from "./components/UpdateCategory";
import { useState } from "react";
import DeleteCategory from "./components/DeleteCategory";
import DetailsPanel from "./components/DetailsPanel";
import UploadImage from "./components/UploadImage";
import { fetchCategories } from "../../../api/categories";
import placeholder from "../../../assets/images/placeholder.png";

export default function AllCategories() {
  const [selected, setSelected] = useState<any>({});
  const [updateModal, setUpdateModal] = useState<boolean>(false);
  const [uploadModal, setUploadModal] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [detailModal, setDetailModal] = useState<boolean>(false);
  const { data, isError } = useQuery({
    queryKey: ["categories"],
    queryFn: fetchCategories,
  });
  return (
    <ManageWrapper
      title={"Categories"}
      subtitle={"List of all categories"}
      actions={
        <>
          <CreateCountry />
        </>
      }
    >
      <div className="mb-16">
        {isError ? (
          <div className="py-2">
            <Something />
          </div>
        ) : (
          <div className="">
            <div className="flex justify-between border-b items-center bg-gray-100 p-2">
              <div className="flex justify-center">
                <div className="w-12">Icon</div>
                <div className="w-24">Name</div>
                <div className="w-24">Index</div>
                <div className="w-24">Active</div>
                <div className="w-16">Count</div>
              </div>
              <div className="">Actions</div>
            </div>
            {data?.map((item: any, index: number) => (
              <div
                className="flex justify-between border-b items-center p-2"
                key={index}
              >
                <div className="flex justify-center">
                  <button
                    className="w-12"
                    onClick={() => {
                      setSelected(item);
                      setUploadModal(true);
                    }}
                  >
                    <img src={item?.icon || placeholder} alt="" />
                  </button>
                  <div className="w-24">{item?.name}</div>
                  <div className="w-24">{item?.index}</div>
                  <div className="w-24">{item?.is_active ? "Yes" : "No"}</div>
                  <div className="w-16">{item?.count}</div>
                </div>
                <div className="flex">
                  <button
                    onClick={() => {
                      setSelected(item);
                      setUpdateModal(true);
                    }}
                    className="border bg-yellow-100 rounded-md p-2 mr-1"
                  >
                    <FiEdit />
                  </button>
                  <button
                    onClick={() => {
                      setSelected(item);
                      setDeleteModal(true);
                    }}
                    className="border bg-red-100 rounded-md p-2 mr-1"
                  >
                    <RiDeleteBin4Line />
                  </button>
                  <button
                    onClick={() => {
                      setSelected(item);
                      setDetailModal(true);
                    }}
                    className="border bg-blue-100 rounded-md p-2"
                  >
                    <BsEye />
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
        <UpdateCategory
          isVisible={updateModal}
          setVisible={setUpdateModal}
          selected={selected}
          setSelected={setSelected}
        />
        <DeleteCategory
          isVisible={deleteModal}
          setVisible={setDeleteModal}
          selected={selected}
          setSelected={setSelected}
        />
        <DetailsPanel
          isVisible={detailModal}
          setVisible={setDetailModal}
          selected={selected}
          setSelected={setSelected}
        />
        <UploadImage
          isVisible={uploadModal}
          setVisible={setUploadModal}
          selected={selected}
          setSelected={setSelected}
        />
      </div>
    </ManageWrapper>
  );
}
